import { debounce } from 'lodash';

export default {
  data() {
    const data = {
      status: null,
      statuses: [],
    };
    data.statuses.allStatusesItem = { ID: null, Name: 'All Statuses' };
    data.statuses.default = data.statuses.allStatusesItem;
    data.statuses.byId = {};
    return data;
  },
  methods: {
    getStatuses(withAll = false) {
      return withAll ? [this.statuses.allStatusesItem, ...this.statuses] : this.statuses;
    },
    async fetchStatuses() {
      this.$startLoading('statuses');

      const statuses = await this.$api.projects.statuses.index();
      statuses.allStatusesItem = this.statuses.allStatusesItem;
      statuses.default = this.statuses.default;
      statuses.byId = statuses.reduce((acc, status) => ({ ...acc, [status.ID]: status }), {});
      this.statuses = statuses;

      const statusActive = statuses.find(status => status.ID === 1);
      if (statusActive) {
        this.setStatus(statusActive);
      }

      if (!this.status) {
        this.setStatus(this.getDefaultStatus());
      }
      this.$stopLoading('statuses');
      return this.statuses;
    },
    getStatus(field) {
      if (!this.status) {
        return undefined;
      }
      return field ? this.status[field] : this.status;
    },
    getStatusBy(field, value) {
      return field === 'ID' ? this.statuses.byId[value] : this.statuses.find(status => status[field] === value);
    },
    setStatusDebounce(status) {
      if (status !== this.status) {
        this.$startLoading('statuses');
        this._setStatusDebounce(status);
      }
    },
    _setStatusDebounce: debounce(function setStatusDebounce(status) {
      this.setStatus(status);
      this.$stopLoading('statuses');
    }, 200),
    setStatus(status) {
      this.status = status;
    },
    setAllStatusesItem(name) {
      this.statuses.allStatusesItem.Name = name;
    },
    getDefaultStatus() {
      return this.statuses.default;
    },
    setDefaultStatus(status) {
      this.statuses.default = status;
    },
  },
  watch: {
    status() {
      if (!this.status) {
        this.$nextTick(() => {
          this.setStatus(this.getDefaultStatus());
        });
      }
    },
  },
};
